import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Adyen store to manage Adyen payment-related data such as whether to load the Adyen SDK.
 * The store persists data in sessionStorage to maintain state across page
 * reloads within the same session.
 */
export const useAdyenStore = defineStore(
    "adyen",
    () => {
        // ── State ──────────────────────────────────────────────────────────────
        const loadAdyenSDK = ref(false);
        const isPaymentActionInProgress = ref(false);
        // WeChat QR is a distinct, long-lived action (QR shown while the user
        // completes payment in the WeChat app). It is tracked separately from
        // isPaymentActionInProgress so that unrelated Adyen actions (e.g. card
        // 3DS) do not trigger the WeChat-specific lock UX.
        const isWeChatActionInProgress = ref(false);

        // ── Actions ────────────────────────────────────────────────────────────
        function setLoadAdyenSDK(load: boolean) {
            loadAdyenSDK.value = load;
        }

        function setIsPaymentActionInProgress(value: boolean) {
            isPaymentActionInProgress.value = value;
        }

        function setIsWeChatActionInProgress(value: boolean) {
            isWeChatActionInProgress.value = value;
        }

        return {
            loadAdyenSDK,
            setLoadAdyenSDK,
            isPaymentActionInProgress,
            setIsPaymentActionInProgress,
            isWeChatActionInProgress,
            setIsWeChatActionInProgress,
        };
    },
    {
        persist: {
            pick: ["loadAdyenSDK"],
            storage: sessionStorage,
        },
    },
);
